// src/pages/ContactUs.js
import React, { useState } from 'react';
import '../styles/pages/Page.css';
import '../styles/pages/LegalPage.css';
import '../styles/pages/Auth.css';
import Mascot from '../components/Mascot';
import { getFriendlyError } from '../components/errorUtils';
import { useAuth } from '../contexts/AuthContext'; // add this

const ContactUs = () => {
  const { user } = useAuth(); // add this

  const [formData, setFormData] = useState({
    name: user?.display_name || user?.email?.split('@')[0] || '',  // same pattern as ProfilePage
    email: user?.email || '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.email.trim() || !formData.message.trim()) {
      setError(getFriendlyError('Please fill in all fields.', 'Contact Us'));
      return;
    }

    setError('');
    setLoading(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.detail || 'Something went wrong.');
      }

      setSubmitted(true);
    } catch (err) {
      setError(getFriendlyError(err.message, 'Contact Us'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="container legal-container">
        <div className="legal-header">
          <p className="m-eyebrow">Support</p>
          <h1 className="page-title">Contact us</h1>
          <p className="legal-last-updated">We usually reply within 1–2 business days.</p>
        </div>

        <div className="contact-grid">
          <section className="contact-intro">
            <p>
              Have a question, found a bug, or want to give feedback? Fill out the form
              below or reach us directly at{' '}
              <a href="mailto:michii.support@gmail.com" className="legal-inline-link">
                michii.support@gmail.com
              </a>.
            </p>
            <div className="auth-say contact-say">
              <Mascot size={40} />
              <div className="auth-say__bubble">
                <b>Michii says</b>
                <span>Bug reports with a guide link get fixed fastest.</span>
              </div>
            </div>
          </section>

          {submitted ? (
            <div className="contact-success m-sheet" role="status">
              <span className="contact-success-icon" aria-hidden="true">✓</span>
              <h3>Message sent</h3>
              <p>Thanks for reaching out. We'll get back to you at <strong>{formData.email}</strong>.</p>
            </div>
          ) : (
            <section className="contact-sheet m-sheet">
              {error && <p className="contact-error" role="alert">{error}</p>}
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="contact-field">
                  <label htmlFor="name" className="contact-label">Name</label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    className="contact-input"
                    placeholder="Your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="contact-field">
                  <label htmlFor="email" className="contact-label">
                    Email
                    {user && <span className="contact-label__hint">(from your account)</span>}
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    className="contact-input"
                    placeholder="you@example.com"
                    value={formData.email}
                    onChange={handleChange}
                    disabled={!!user}           // locked if logged in
                    required
                  />
                </div>

                <div className="contact-field">
                  <label htmlFor="message" className="contact-label">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    className="contact-input contact-textarea"
                    placeholder="Tell us what's on your mind..."
                    rows={6}
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="cta-button primary contact-submit"
                  disabled={loading}
                >
                  {loading ? 'Sending…' : 'Send message'}
                </button>
              </form>
            </section>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactUs;